import DialogContent from "@material-ui/core/DialogContent";
import { PassProps } from "components/_helpers/PassProps";
import { GridForm, GridInput } from "components/GridForm";
import { YesNoInput } from "components/inputs";
import { SelectEnumInput } from "components/inputs/SelectEnumInput";
import { FieldType } from "entities/FieldType";
import React from "react";
import { TextInput, required } from "react-admin";

export const AddEditCustomFieldBody = ({ form, ...rest }) => {
	return (
		<PassProps
			component={DialogContent}
			childPropKeys={["resource", "record"]}
			resource="custom-fields"
			{...rest}
		>
			<GridForm>
				<GridInput
					md={12}
					component={TextInput}
					source="name"
					label="resources.custom-fields.fields.name"
					validate={required()}
				/>
				<GridInput
					md={12}
					component={SelectEnumInput}
					source="type"
					label="resources.custom-fields.fields.type"
					enumName="field-type"
					enumObj={FieldType}
					validate={required()}
				/>
				<GridInput
					md={12}
					component={YesNoInput}
					source="is_show_on_grid"
					label="resources.custom-fields.fields.is_show_on_grid"
					validate={required()}
					defaultValue={true}
				/>
			</GridForm>
		</PassProps>
	);
};
